import React, { createElement } from 'react';
import styled from 'styled-components';
import { Colors, Color } from '../styles/Colors';

const Overlay = styled.div`
  display: grid;
  grid-template-columns: minmax(16px, 1fr) [inner-start] minmax(0, 50rem) [inner-end] minmax(16px, 1fr);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999999;
  background-color: ${Color(Colors.white)}; 
`;

const Content = styled.div`
  grid-column: inner; 
  display: flex;
  flex-direction: column; 
  justify-content: center;
  align-items: center;
`; 

const TextWrapper = styled.div`
  display: flex; 
  flex-direction: column; 
  justify-content: center;
  align-items: center;
  text-align: center; 
  padding: 2rem 0 0 0; 

  h4, 
  h5 {
    color: ${Color(Colors.black)}; 
  }

  h5 {
    font-weight: 400; 
  }
`; 

const LoadingOverlay = ({icon, title, subTitle, iconFill}) => {

  return (
    <Overlay>
      <Content>
        {icon && createElement(icon, {$height: 100, $width: 100, $fill: iconFill})}
        <TextWrapper>
          {title && <h2>{title}</h2>}
          {subTitle && <h5>{subTitle}</h5>}
        </TextWrapper>
      </Content>
    </Overlay>
  );
}

export default LoadingOverlay;
